@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(738_536_844)
public val Res.string.roster_availability_no_answer: StringResource by lazy {
      StringResource("string:roster_availability_no_answer", "roster_availability_no_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246793, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350377, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225728, 65),
      ))
    }

@delegate:ResourceContentHash(-1_468_224_333)
public val Res.string.roster_build_title: StringResource by lazy {
      StringResource("string:roster_build_title", "roster_build_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246938, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350590, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225861, 58),
      ))
    }

@delegate:ResourceContentHash(1_447_608_310)
public val Res.string.roster_build_title_loading: StringResource by lazy {
      StringResource("string:roster_build_title_loading", "roster_build_title_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246859, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350471, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225794, 66),
      ))
    }

@delegate:ResourceContentHash(843_753_990)
public val Res.string.roster_builder_title: StringResource by lazy {
      StringResource("string:roster_builder_title", "roster_builder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247005, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350677, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225920, 64),
      ))
    }

@delegate:ResourceContentHash(268_274_607)
public val Res.string.roster_cancel_addition: StringResource by lazy {
      StringResource("string:roster_cancel_addition", "roster_cancel_addition", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247074, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350766, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225985, 50),
      ))
    }

@delegate:ResourceContentHash(1_790_983_147)
public val Res.string.roster_card_capacity_action: StringResource by lazy {
      StringResource("string:roster_card_capacity_action", "roster_card_capacity_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247129, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350849, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226036, 67),
      ))
    }

@delegate:ResourceContentHash(895_084_105)
public val Res.string.roster_card_capacity_title: StringResource by lazy {
      StringResource("string:roster_card_capacity_title", "roster_card_capacity_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247213, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350941, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226104, 54),
      ))
    }

@delegate:ResourceContentHash(-1_559_529_551)
public val Res.string.roster_cell_copied: StringResource by lazy {
      StringResource("string:roster_cell_copied", "roster_cell_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247268, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351008, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226159, 70),
      ))
    }

@delegate:ResourceContentHash(-326_523_373)
public val Res.string.roster_cells_skipped: StringResource by lazy {
      StringResource("string:roster_cells_skipped", "roster_cells_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247343, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351115, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226230, 100),
      ))
    }

@delegate:ResourceContentHash(-2_106_078_940)
public val Res.string.roster_conflicts: StringResource by lazy {
      StringResource("string:roster_conflicts", "roster_conflicts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247460, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351308, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226331, 36),
      ))
    }

@delegate:ResourceContentHash(1_513_003_599)
public val Res.string.roster_create_custom: StringResource by lazy {
      StringResource("string:roster_create_custom", "roster_create_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247497, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351357, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226368, 56),
      ))
    }

@delegate:ResourceContentHash(337_512_597)
public val Res.string.roster_day_add_shift: StringResource by lazy {
      StringResource("string:roster_day_add_shift", "roster_day_add_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247748, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351700, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226575, 40),
      ))
    }

@delegate:ResourceContentHash(-1_288_687_984)
public val Res.string.roster_day_add_shift_hint: StringResource by lazy {
      StringResource("string:roster_day_add_shift_hint", "roster_day_add_shift_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247558, 189),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351442, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226425, 149),
      ))
    }

@delegate:ResourceContentHash(-68_472_247)
public val Res.string.roster_day_assign: StringResource by lazy {
      StringResource("string:roster_day_assign", "roster_day_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247797, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351761, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226616, 33),
      ))
    }

@delegate:ResourceContentHash(752_648_591)
public val Res.string.roster_day_copy_this: StringResource by lazy {
      StringResource("string:roster_day_copy_this", "roster_day_copy_this", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247835, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351815, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226650, 52),
      ))
    }

@delegate:ResourceContentHash(1_620_980_906)
public val Res.string.roster_day_no_lead: StringResource by lazy {
      StringResource("string:roster_day_no_lead", "roster_day_no_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247892, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351896, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226703, 62),
      ))
    }

@delegate:ResourceContentHash(-402_946_197)
public val Res.string.roster_day_only_supervised: StringResource by lazy {
      StringResource("string:roster_day_only_supervised", "roster_day_only_supervised", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 247967, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 351999, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226766, 94),
      ))
    }

@delegate:ResourceContentHash(1_962_235_231)
public val Res.string.roster_day_unsupervised_hours: StringResource by lazy {
      StringResource("string:roster_day_unsupervised_hours", "roster_day_unsupervised_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248070, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352166, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226861, 89),
      ))
    }

@delegate:ResourceContentHash(-1_285_493_543)
public val Res.string.roster_delete: StringResource by lazy {
      StringResource("string:roster_delete", "roster_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248749, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353117, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227516, 41),
      ))
    }

@delegate:ResourceContentHash(-126_123_179)
public val Res.string.roster_delete_confirm: StringResource by lazy {
      StringResource("string:roster_delete_confirm", "roster_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248160, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352296, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226951, 85),
      ))
    }

@delegate:ResourceContentHash(-827_842_145)
public val Res.string.roster_delete_shift: StringResource by lazy {
      StringResource("string:roster_delete_shift", "roster_delete_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248654, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352990, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227429, 43),
      ))
    }

@delegate:ResourceContentHash(1_138_935_499)
public val Res.string.roster_delete_shift_text_assigned: StringResource by lazy {
      StringResource("string:roster_delete_shift_text_assigned", "roster_delete_shift_text_assigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248254, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352442, 237),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227037, 161),
      ))
    }

@delegate:ResourceContentHash(-1_018_356_418)
public val Res.string.roster_delete_shift_text_unassigned: StringResource by lazy {
      StringResource("string:roster_delete_shift_text_unassigned", "roster_delete_shift_text_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248420, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352680, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227199, 171),
      ))
    }

@delegate:ResourceContentHash(1_639_100_025)
public val Res.string.roster_delete_shift_title: StringResource by lazy {
      StringResource("string:roster_delete_shift_title", "roster_delete_shift_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248592, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 352912, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227371, 57),
      ))
    }

@delegate:ResourceContentHash(-2_119_223_410)
public val Res.string.roster_deleted: StringResource by lazy {
      StringResource("string:roster_deleted", "roster_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248702, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353054, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227473, 42),
      ))
    }

@delegate:ResourceContentHash(-1_385_914_292)
public val Res.string.roster_edit_shift: StringResource by lazy {
      StringResource("string:roster_edit_shift", "roster_edit_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248787, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353179, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227558, 41),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.roster_employee: StringResource by lazy {
      StringResource("string:roster_employee", "roster_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248833, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353249, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227600, 35),
      ))
    }

@delegate:ResourceContentHash(-1_129_610_551)
public val Res.string.roster_empty_create: StringResource by lazy {
      StringResource("string:roster_empty_create", "roster_empty_create", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248869, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353297, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227636, 63),
      ))
    }

@delegate:ResourceContentHash(1_534_026_173)
public val Res.string.roster_empty_step_availability: StringResource by lazy {
      StringResource("string:roster_empty_step_availability", "roster_empty_step_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 248929, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353377, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227700, 102),
      ))
    }

@delegate:ResourceContentHash(-1_239_359_104)
public val Res.string.roster_empty_step_demand: StringResource by lazy {
      StringResource("string:roster_empty_step_demand", "roster_empty_step_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249044, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353536, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227803, 68),
      ))
    }

@delegate:ResourceContentHash(-190_161_030)
public val Res.string.roster_empty_step_publish: StringResource by lazy {
      StringResource("string:roster_empty_step_publish", "roster_empty_step_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249133, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353649, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227872, 85),
      ))
    }

@delegate:ResourceContentHash(-337_518_003)
public val Res.string.roster_empty_steps_title: StringResource by lazy {
      StringResource("string:roster_empty_steps_title", "roster_empty_steps_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249219, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353775, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227958, 64),
      ))
    }

@delegate:ResourceContentHash(1_402_974_260)
public val Res.string.roster_end_time: StringResource by lazy {
      StringResource("string:roster_end_time", "roster_end_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249280, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353860, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228023, 35),
      ))
    }

@delegate:ResourceContentHash(848_877_804)
public val Res.string.roster_from: StringResource by lazy {
      StringResource("string:roster_from", "roster_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249423, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354059, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228166, 27),
      ))
    }

@delegate:ResourceContentHash(-1_027_438_220)
public val Res.string.roster_from_skeleton: StringResource by lazy {
      StringResource("string:roster_from_skeleton", "roster_from_skeleton", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249312, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 353920, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228059, 56),
      ))
    }

@delegate:ResourceContentHash(-770_555_895)
public val Res.string.roster_from_templates: StringResource by lazy {
      StringResource("string:roster_from_templates", "roster_from_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249377, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354001, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228116, 49),
      ))
    }

@delegate:ResourceContentHash(890_189_907)
public val Res.string.roster_grid_added: StringResource by lazy {
      StringResource("string:roster_grid_added", "roster_grid_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249447, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354087, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228194, 49),
      ))
    }

@delegate:ResourceContentHash(1_736_980_813)
public val Res.string.roster_grid_label: StringResource by lazy {
      StringResource("string:roster_grid_label", "roster_grid_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249501, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354153, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228244, 101),
      ))
    }

@delegate:ResourceContentHash(-2_086_153_025)
public val Res.string.roster_grid_moved: StringResource by lazy {
      StringResource("string:roster_grid_moved", "roster_grid_moved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249611, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354327, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228346, 41),
      ))
    }

@delegate:ResourceContentHash(726_377_421)
public val Res.string.roster_grid_unassigned: StringResource by lazy {
      StringResource("string:roster_grid_unassigned", "roster_grid_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249665, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354397, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228388, 62),
      ))
    }

@delegate:ResourceContentHash(1_434_263_811)
public val Res.string.roster_grid_undone: StringResource by lazy {
      StringResource("string:roster_grid_undone", "roster_grid_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249736, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354488, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228451, 38),
      ))
    }

@delegate:ResourceContentHash(-1_637_511_564)
public val Res.string.roster_import_absence_label: StringResource by lazy {
      StringResource("string:roster_import_absence_label", "roster_import_absence_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249779, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354543, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228490, 55),
      ))
    }

@delegate:ResourceContentHash(-307_844_301)
public val Res.string.roster_import_absence_line: StringResource by lazy {
      StringResource("string:roster_import_absence_line", "roster_import_absence_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249843, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354619, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228546, 62),
      ))
    }

@delegate:ResourceContentHash(-696_572_006)
public val Res.string.roster_import_absence_note: StringResource by lazy {
      StringResource("string:roster_import_absence_note", "roster_import_absence_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 249906, 238),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 354686, 378),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228609, 214),
      ))
    }

@delegate:ResourceContentHash(-27_709_323)
public val Res.string.roster_import_absences_title: StringResource by lazy {
      StringResource("string:roster_import_absences_title", "roster_import_absences_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250145, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355065, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228824, 64),
      ))
    }

@delegate:ResourceContentHash(-941_109_445)
public val Res.string.roster_import_action_absence: StringResource by lazy {
      StringResource("string:roster_import_action_absence", "roster_import_action_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250238, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355190, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228889, 52),
      ))
    }

@delegate:ResourceContentHash(1_056_296_237)
public val Res.string.roster_import_action_day_off: StringResource by lazy {
      StringResource("string:roster_import_action_day_off", "roster_import_action_day_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250295, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355259, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228942, 48),
      ))
    }

@delegate:ResourceContentHash(-1_395_690_406)
public val Res.string.roster_import_action_ignore: StringResource by lazy {
      StringResource("string:roster_import_action_ignore", "roster_import_action_ignore", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250348, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355320, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228991, 47),
      ))
    }

@delegate:ResourceContentHash(-233_633_581)
public val Res.string.roster_import_action_none: StringResource by lazy {
      StringResource("string:roster_import_action_none", "roster_import_action_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250392, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355384, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229039, 45),
      ))
    }

@delegate:ResourceContentHash(1_536_144_960)
public val Res.string.roster_import_action_shift: StringResource by lazy {
      StringResource("string:roster_import_action_shift", "roster_import_action_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250442, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355438, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229085, 58),
      ))
    }

@delegate:ResourceContentHash(-1_211_240_557)
public val Res.string.roster_import_action_template: StringResource by lazy {
      StringResource("string:roster_import_action_template", "roster_import_action_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250501, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355513, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229144, 61),
      ))
    }

@delegate:ResourceContentHash(510_016_351)
public val Res.string.roster_import_add_all_new: StringResource by lazy {
      StringResource("string:roster_import_add_all_new", "roster_import_add_all_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250559, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355583, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229206, 85),
      ))
    }

@delegate:ResourceContentHash(323_599_801)
public val Res.string.roster_import_back_to_codes: StringResource by lazy {
      StringResource("string:roster_import_back_to_codes", "roster_import_back_to_codes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250657, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355705, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229292, 59),
      ))
    }

@delegate:ResourceContentHash(1_704_275_965)
public val Res.string.roster_import_back_to_layout: StringResource by lazy {
      StringResource("string:roster_import_back_to_layout", "roster_import_back_to_layout", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250721, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355785, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229352, 60),
      ))
    }

@delegate:ResourceContentHash(-669_138_738)
public val Res.string.roster_import_back_to_people: StringResource by lazy {
      StringResource("string:roster_import_back_to_people", "roster_import_back_to_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250782, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355878, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229413, 60),
      ))
    }

@delegate:ResourceContentHash(706_270_013)
public val Res.string.roster_import_checking: StringResource by lazy {
      StringResource("string:roster_import_checking", "roster_import_checking", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250839, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 355951, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229474, 98),
      ))
    }

@delegate:ResourceContentHash(-848_544_278)
public val Res.string.roster_import_choice_new: StringResource by lazy {
      StringResource("string:roster_import_choice_new", "roster_import_choice_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 250946, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356106, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229573, 72),
      ))
    }

@delegate:ResourceContentHash(-2_055_626_569)
public val Res.string.roster_import_choice_skip: StringResource by lazy {
      StringResource("string:roster_import_choice_skip", "roster_import_choice_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251019, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356215, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229646, 53),
      ))
    }

@delegate:ResourceContentHash(-233_633_581)
public val Res.string.roster_import_choice_undecided: StringResource by lazy {
      StringResource("string:roster_import_choice_undecided", "roster_import_choice_undecided", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251077, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356301, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229700, 50),
      ))
    }

@delegate:ResourceContentHash(569_994_524)
public val Res.string.roster_import_closed: StringResource by lazy {
      StringResource("string:roster_import_closed", "roster_import_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251132, 156),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356360, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229751, 140),
      ))
    }

@delegate:ResourceContentHash(74_483_942)
public val Res.string.roster_import_code_from_dictionary: StringResource by lazy {
      StringResource("string:roster_import_code_from_dictionary", "roster_import_code_from_dictionary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251289, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356569, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229892, 86),
      ))
    }

@delegate:ResourceContentHash(-1_989_177_057)
public val Res.string.roster_import_code_means: StringResource by lazy {
      StringResource("string:roster_import_code_means", "roster_import_code_means", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251384, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356700, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229979, 40),
      ))
    }

@delegate:ResourceContentHash(458_095_060)
public val Res.string.roster_import_code_quoted: StringResource by lazy {
      StringResource("string:roster_import_code_quoted", "roster_import_code_quoted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251429, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356753, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230020, 49),
      ))
    }

@delegate:ResourceContentHash(1_847_955_770)
public val Res.string.roster_import_code_suggested: StringResource by lazy {
      StringResource("string:roster_import_code_suggested", "roster_import_code_suggested", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251479, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356799, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230070, 80),
      ))
    }

@delegate:ResourceContentHash(1_037_731_957)
public val Res.string.roster_import_code_undecided: StringResource by lazy {
      StringResource("string:roster_import_code_undecided", "roster_import_code_undecided", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251568, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 356912, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230151, 116),
      ))
    }

@delegate:ResourceContentHash(62_046_879)
public val Res.string.roster_import_codes_hint: StringResource by lazy {
      StringResource("string:roster_import_codes_hint", "roster_import_codes_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251709, 248),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357105, 380),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230268, 232),
      ))
    }

@delegate:ResourceContentHash(-947_476_124)
public val Res.string.roster_import_codes_next: StringResource by lazy {
      StringResource("string:roster_import_codes_next", "roster_import_codes_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 251958, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357486, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230501, 56),
      ))
    }

@delegate:ResourceContentHash(-120_896_592)
public val Res.string.roster_import_codes_title: StringResource by lazy {
      StringResource("string:roster_import_codes_title", "roster_import_codes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252007, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357543, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230558, 65),
      ))
    }

@delegate:ResourceContentHash(-663_343_138)
public val Res.string.roster_import_count_new_people: StringResource by lazy {
      StringResource("string:roster_import_count_new_people", "roster_import_count_new_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252073, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357633, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230624, 54),
      ))
    }

@delegate:ResourceContentHash(-551_931_811)
public val Res.string.roster_import_count_problems: StringResource by lazy {
      StringResource("string:roster_import_count_problems", "roster_import_count_problems", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252128, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357696, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230679, 64),
      ))
    }

@delegate:ResourceContentHash(-29_390_595)
public val Res.string.roster_import_count_shifts: StringResource by lazy {
      StringResource("string:roster_import_count_shifts", "roster_import_count_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252221, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357845, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230744, 58),
      ))
    }

@delegate:ResourceContentHash(339_410_558)
public val Res.string.roster_import_count_skipped: StringResource by lazy {
      StringResource("string:roster_import_count_skipped", "roster_import_count_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252284, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 357928, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230803, 55),
      ))
    }

@delegate:ResourceContentHash(2_096_270_429)
public val Res.string.roster_import_count_without_person: StringResource by lazy {
      StringResource("string:roster_import_count_without_person", "roster_import_count_without_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252348, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358012, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230859, 82),
      ))
    }

@delegate:ResourceContentHash(-1_825_118_785)
public val Res.string.roster_import_done_absences: StringResource by lazy {
      StringResource("string:roster_import_done_absences", "roster_import_done_absences", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252435, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358135, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230942, 67),
      ))
    }

@delegate:ResourceContentHash(1_380_660_549)
public val Res.string.roster_import_done_back: StringResource by lazy {
      StringResource("string:roster_import_done_back", "roster_import_done_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252519, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358255, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231010, 55),
      ))
    }

@delegate:ResourceContentHash(547_079_818)
public val Res.string.roster_import_done_created: StringResource by lazy {
      StringResource("string:roster_import_done_created", "roster_import_done_created", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252575, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358327, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231066, 54),
      ))
    }

@delegate:ResourceContentHash(-1_376_741_441)
public val Res.string.roster_import_done_hint: StringResource by lazy {
      StringResource("string:roster_import_done_hint", "roster_import_done_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252634, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358398, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231121, 123),
      ))
    }

@delegate:ResourceContentHash(2_015_673_530)
public val Res.string.roster_import_done_new_people: StringResource by lazy {
      StringResource("string:roster_import_done_new_people", "roster_import_done_new_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252758, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358590, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231245, 69),
      ))
    }

@delegate:ResourceContentHash(631_465_344)
public val Res.string.roster_import_done_replaced: StringResource by lazy {
      StringResource("string:roster_import_done_replaced", "roster_import_done_replaced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252824, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358676, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231315, 67),
      ))
    }

@delegate:ResourceContentHash(-420_617_777)
public val Res.string.roster_import_done_skipped_closed: StringResource by lazy {
      StringResource("string:roster_import_done_skipped_closed", "roster_import_done_skipped_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 252904, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358776, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231383, 101),
      ))
    }

@delegate:ResourceContentHash(742_388_395)
public val Res.string.roster_import_done_skipped_planned: StringResource by lazy {
      StringResource("string:roster_import_done_skipped_planned", "roster_import_done_skipped_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253002, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 358910, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231485, 94),
      ))
    }

@delegate:ResourceContentHash(156_797_799)
public val Res.string.roster_import_done_title: StringResource by lazy {
      StringResource("string:roster_import_done_title", "roster_import_done_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253097, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359029, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231580, 52),
      ))
    }

@delegate:ResourceContentHash(1_799_813_240)
public val Res.string.roster_import_edit_hint: StringResource by lazy {
      StringResource("string:roster_import_edit_hint", "roster_import_edit_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253158, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359110, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231633, 111),
      ))
    }

@delegate:ResourceContentHash(360_288_792)
public val Res.string.roster_import_edit_label: StringResource by lazy {
      StringResource("string:roster_import_edit_label", "roster_import_edit_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253278, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359274, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231745, 40),
      ))
    }

@delegate:ResourceContentHash(1_802_772_023)
public val Res.string.roster_import_edit_original: StringResource by lazy {
      StringResource("string:roster_import_edit_original", "roster_import_edit_original", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253323, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359331, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231786, 75),
      ))
    }

@delegate:ResourceContentHash(740_360_672)
public val Res.string.roster_import_edit_save: StringResource by lazy {
      StringResource("string:roster_import_edit_save", "roster_import_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253399, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359427, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231862, 51),
      ))
    }

@delegate:ResourceContentHash(-1_304_211_018)
public val Res.string.roster_import_edit_title: StringResource by lazy {
      StringResource("string:roster_import_edit_title", "roster_import_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253455, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359515, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231914, 48),
      ))
    }

@delegate:ResourceContentHash(-433_329_998)
public val Res.string.roster_import_empty_action: StringResource by lazy {
      StringResource("string:roster_import_empty_action", "roster_import_empty_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253504, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359564, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231963, 70),
      ))
    }

@delegate:ResourceContentHash(-1_104_160_557)
public val Res.string.roster_import_empty_hint: StringResource by lazy {
      StringResource("string:roster_import_empty_hint", "roster_import_empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253563, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359655, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232034, 144),
      ))
    }

@delegate:ResourceContentHash(-730_599_632)
public val Res.string.roster_import_first_day_date: StringResource by lazy {
      StringResource("string:roster_import_first_day_date", "roster_import_first_day_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253842, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360050, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232309, 76),
      ))
    }

@delegate:ResourceContentHash(-196_901_171)
public val Res.string.roster_import_first_day_date_hint: StringResource by lazy {
      StringResource("string:roster_import_first_day_date_hint", "roster_import_first_day_date_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253696, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 359848, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232179, 129),
      ))
    }

@delegate:ResourceContentHash(-1_089_300_787)
public val Res.string.roster_import_first_day_set: StringResource by lazy {
      StringResource("string:roster_import_first_day_set", "roster_import_first_day_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253919, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360151, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232386, 67),
      ))
    }

@delegate:ResourceContentHash(203_584_202)
public val Res.string.roster_import_first_day_unset: StringResource by lazy {
      StringResource("string:roster_import_first_day_unset", "roster_import_first_day_unset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 253999, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360251, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232454, 101),
      ))
    }

@delegate:ResourceContentHash(726_221_540)
public val Res.string.roster_import_fix_first: StringResource by lazy {
      StringResource("string:roster_import_fix_first", "roster_import_fix_first", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254105, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360401, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232556, 103),
      ))
    }

@delegate:ResourceContentHash(-112_765_591)
public val Res.string.roster_import_header_below_first_day: StringResource by lazy {
      StringResource("string:roster_import_header_below_first_day", "roster_import_header_below_first_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254229, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360589, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232660, 124),
      ))
    }

@delegate:ResourceContentHash(780_828_666)
public val Res.string.roster_import_header_clear: StringResource by lazy {
      StringResource("string:roster_import_header_clear", "roster_import_header_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254346, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360758, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232785, 86),
      ))
    }

@delegate:ResourceContentHash(76_879_079)
public val Res.string.roster_import_header_set: StringResource by lazy {
      StringResource("string:roster_import_header_set", "roster_import_header_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254429, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 360885, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232872, 108),
      ))
    }

@delegate:ResourceContentHash(1_701_214_369)
public val Res.string.roster_import_header_unset: StringResource by lazy {
      StringResource("string:roster_import_header_unset", "roster_import_header_unset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254554, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 361066, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232981, 106),
      ))
    }

@delegate:ResourceContentHash(-855_687_480)
public val Res.string.roster_import_include_cell: StringResource by lazy {
      StringResource("string:roster_import_include_cell", "roster_import_include_cell", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254669, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 361245, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233088, 54),
      ))
    }

@delegate:ResourceContentHash(1_175_387_200)
public val Res.string.roster_import_intro: StringResource by lazy {
      StringResource("string:roster_import_intro", "roster_import_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 254732, 291),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 361320, 447),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233143, 271),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString31Resources(map: MutableMap<String, StringResource>) {
  map.put("roster_availability_no_answer", Res.string.roster_availability_no_answer)
  map.put("roster_build_title", Res.string.roster_build_title)
  map.put("roster_build_title_loading", Res.string.roster_build_title_loading)
  map.put("roster_builder_title", Res.string.roster_builder_title)
  map.put("roster_cancel_addition", Res.string.roster_cancel_addition)
  map.put("roster_card_capacity_action", Res.string.roster_card_capacity_action)
  map.put("roster_card_capacity_title", Res.string.roster_card_capacity_title)
  map.put("roster_cell_copied", Res.string.roster_cell_copied)
  map.put("roster_cells_skipped", Res.string.roster_cells_skipped)
  map.put("roster_conflicts", Res.string.roster_conflicts)
  map.put("roster_create_custom", Res.string.roster_create_custom)
  map.put("roster_day_add_shift", Res.string.roster_day_add_shift)
  map.put("roster_day_add_shift_hint", Res.string.roster_day_add_shift_hint)
  map.put("roster_day_assign", Res.string.roster_day_assign)
  map.put("roster_day_copy_this", Res.string.roster_day_copy_this)
  map.put("roster_day_no_lead", Res.string.roster_day_no_lead)
  map.put("roster_day_only_supervised", Res.string.roster_day_only_supervised)
  map.put("roster_day_unsupervised_hours", Res.string.roster_day_unsupervised_hours)
  map.put("roster_delete", Res.string.roster_delete)
  map.put("roster_delete_confirm", Res.string.roster_delete_confirm)
  map.put("roster_delete_shift", Res.string.roster_delete_shift)
  map.put("roster_delete_shift_text_assigned", Res.string.roster_delete_shift_text_assigned)
  map.put("roster_delete_shift_text_unassigned", Res.string.roster_delete_shift_text_unassigned)
  map.put("roster_delete_shift_title", Res.string.roster_delete_shift_title)
  map.put("roster_deleted", Res.string.roster_deleted)
  map.put("roster_edit_shift", Res.string.roster_edit_shift)
  map.put("roster_employee", Res.string.roster_employee)
  map.put("roster_empty_create", Res.string.roster_empty_create)
  map.put("roster_empty_step_availability", Res.string.roster_empty_step_availability)
  map.put("roster_empty_step_demand", Res.string.roster_empty_step_demand)
  map.put("roster_empty_step_publish", Res.string.roster_empty_step_publish)
  map.put("roster_empty_steps_title", Res.string.roster_empty_steps_title)
  map.put("roster_end_time", Res.string.roster_end_time)
  map.put("roster_from", Res.string.roster_from)
  map.put("roster_from_skeleton", Res.string.roster_from_skeleton)
  map.put("roster_from_templates", Res.string.roster_from_templates)
  map.put("roster_grid_added", Res.string.roster_grid_added)
  map.put("roster_grid_label", Res.string.roster_grid_label)
  map.put("roster_grid_moved", Res.string.roster_grid_moved)
  map.put("roster_grid_unassigned", Res.string.roster_grid_unassigned)
  map.put("roster_grid_undone", Res.string.roster_grid_undone)
  map.put("roster_import_absence_label", Res.string.roster_import_absence_label)
  map.put("roster_import_absence_line", Res.string.roster_import_absence_line)
  map.put("roster_import_absence_note", Res.string.roster_import_absence_note)
  map.put("roster_import_absences_title", Res.string.roster_import_absences_title)
  map.put("roster_import_action_absence", Res.string.roster_import_action_absence)
  map.put("roster_import_action_day_off", Res.string.roster_import_action_day_off)
  map.put("roster_import_action_ignore", Res.string.roster_import_action_ignore)
  map.put("roster_import_action_none", Res.string.roster_import_action_none)
  map.put("roster_import_action_shift", Res.string.roster_import_action_shift)
  map.put("roster_import_action_template", Res.string.roster_import_action_template)
  map.put("roster_import_add_all_new", Res.string.roster_import_add_all_new)
  map.put("roster_import_back_to_codes", Res.string.roster_import_back_to_codes)
  map.put("roster_import_back_to_layout", Res.string.roster_import_back_to_layout)
  map.put("roster_import_back_to_people", Res.string.roster_import_back_to_people)
  map.put("roster_import_checking", Res.string.roster_import_checking)
  map.put("roster_import_choice_new", Res.string.roster_import_choice_new)
  map.put("roster_import_choice_skip", Res.string.roster_import_choice_skip)
  map.put("roster_import_choice_undecided", Res.string.roster_import_choice_undecided)
  map.put("roster_import_closed", Res.string.roster_import_closed)
  map.put("roster_import_code_from_dictionary", Res.string.roster_import_code_from_dictionary)
  map.put("roster_import_code_means", Res.string.roster_import_code_means)
  map.put("roster_import_code_quoted", Res.string.roster_import_code_quoted)
  map.put("roster_import_code_suggested", Res.string.roster_import_code_suggested)
  map.put("roster_import_code_undecided", Res.string.roster_import_code_undecided)
  map.put("roster_import_codes_hint", Res.string.roster_import_codes_hint)
  map.put("roster_import_codes_next", Res.string.roster_import_codes_next)
  map.put("roster_import_codes_title", Res.string.roster_import_codes_title)
  map.put("roster_import_count_new_people", Res.string.roster_import_count_new_people)
  map.put("roster_import_count_problems", Res.string.roster_import_count_problems)
  map.put("roster_import_count_shifts", Res.string.roster_import_count_shifts)
  map.put("roster_import_count_skipped", Res.string.roster_import_count_skipped)
  map.put("roster_import_count_without_person", Res.string.roster_import_count_without_person)
  map.put("roster_import_done_absences", Res.string.roster_import_done_absences)
  map.put("roster_import_done_back", Res.string.roster_import_done_back)
  map.put("roster_import_done_created", Res.string.roster_import_done_created)
  map.put("roster_import_done_hint", Res.string.roster_import_done_hint)
  map.put("roster_import_done_new_people", Res.string.roster_import_done_new_people)
  map.put("roster_import_done_replaced", Res.string.roster_import_done_replaced)
  map.put("roster_import_done_skipped_closed", Res.string.roster_import_done_skipped_closed)
  map.put("roster_import_done_skipped_planned", Res.string.roster_import_done_skipped_planned)
  map.put("roster_import_done_title", Res.string.roster_import_done_title)
  map.put("roster_import_edit_hint", Res.string.roster_import_edit_hint)
  map.put("roster_import_edit_label", Res.string.roster_import_edit_label)
  map.put("roster_import_edit_original", Res.string.roster_import_edit_original)
  map.put("roster_import_edit_save", Res.string.roster_import_edit_save)
  map.put("roster_import_edit_title", Res.string.roster_import_edit_title)
  map.put("roster_import_empty_action", Res.string.roster_import_empty_action)
  map.put("roster_import_empty_hint", Res.string.roster_import_empty_hint)
  map.put("roster_import_first_day_date", Res.string.roster_import_first_day_date)
  map.put("roster_import_first_day_date_hint", Res.string.roster_import_first_day_date_hint)
  map.put("roster_import_first_day_set", Res.string.roster_import_first_day_set)
  map.put("roster_import_first_day_unset", Res.string.roster_import_first_day_unset)
  map.put("roster_import_fix_first", Res.string.roster_import_fix_first)
  map.put("roster_import_header_below_first_day", Res.string.roster_import_header_below_first_day)
  map.put("roster_import_header_clear", Res.string.roster_import_header_clear)
  map.put("roster_import_header_set", Res.string.roster_import_header_set)
  map.put("roster_import_header_unset", Res.string.roster_import_header_unset)
  map.put("roster_import_include_cell", Res.string.roster_import_include_cell)
  map.put("roster_import_intro", Res.string.roster_import_intro)
}
